package com.devi3east.bashbuddy.auth.capability

class WebAuthCapability : AuthCapability {
    override fun canAuthenticate() = true
}